import { render } from "./ShopNavbar.vue?vue&type=template&id=5f34bfc9&scoped=true"
import script from "./ShopNavbar.vue?vue&type=script&lang=js"
export * from "./ShopNavbar.vue?vue&type=script&lang=js"

import "./ShopNavbar.vue?vue&type=style&index=0&id=5f34bfc9&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f34bfc9"]])

export default __exports__